export const accountGOSReportFilterFields = {
  REGISTER_CODE: 'registerCode',
  DATE_FROM: 'dateFrom',
  DATE_TO: 'dateTo',
};

export const FORM_ACCOUNT_GOS_REPORT_FILTER = 'FORM_ACCOUNT_GOS_REPORT_FILTER';
